import React from 'react';
import AppWrapper from './AppWrapper';
import {HashRouter} from 'react-router-dom';
import { createRoot } from "react-dom/client";
import * as serviceWorker from './serviceWorker';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'prismjs/themes/prism-coy.css';

const rootElm = document.getElementById('root');
const root = createRoot(rootElm);
root.render(<HashRouter>
		<AppWrapper/>
    </HashRouter>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
